export default __webpack_public_path__ + "static/media/34.971c5777.jpeg";